import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

function Hero() {
  const { t } = useTranslation();

  return (
    <section id="hero">
      <div className="wholeHero">
        <div className="leftHero">
          {/* <StaticImage src="../images/rightHero.png" alt="Logo" /> */}
        </div>
        <div className="rightHero">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <h1>{t("heroTitle")}</h1>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="700">
            <p>{t("heroContent")} </p>
          </AnimatedOnScroll>

          <div className="chevron">
            <a href="#about">
              <StaticImage src="../images/chevron.svg" alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
